import { LitElement, html, css } from 'lit'

customElements.define('k-trip-category', class extends LitElement{

    static properties = {
        name: {type: String, reflect: true}
    }

    static styles = css`
        :host {
            display: block;
            position:relative;
        }

        :host([name="Trekking"]) { --color: var(--green) }
        :host([name="Peak"]) { --color: var(--orange) }
        :host([name="Expedition"]) { --color: var(--orange) }
        :host([name="Adventure"]) { --color: var(--blue) }
    `

    set data(val){
        let oldVal = this.data
        this.__data = val
        this.name = val?.categories?.[0]?.name

        this.requestUpdate('data', oldVal)
    }
    
    get data(){ return this.__data}

    render(){return html`
        ${this.name}
    `}

})

export default customElements.get('k-trip-category')